module.exports = __webpack_public_path__ + "img/undraw_envelope_re_f5j4.90113e1c.svg";